import { render, staticRenderFns } from "./Ecpm.vue?vue&type=template&id=1a6d9540&"
import script from "./Ecpm.vue?vue&type=script&lang=js&"
export * from "./Ecpm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports